<template>
  <div class="limit-radio-column-comp">
    <div>
      <p>
        {{ titleText }}
      </p>
    </div>
    <div class="radios">
      <div
        class="radio"
        v-for="(question, index) in questions"
        :key="`${$route.name}_${$route.name}_radios_${id}_${index}`"
      >
        <div class="radio-input">
          <input
            :id="`__${index}__radio`"
            type="radio"
            v-model="radioFeedback[index]"
            :value="question.value"
            class="limit-rad-input"
          />
          <span>{{ question.value }}</span>
        </div>
        <div class="radio-textarea" v-if="question.textbox">
          <textarea v-model="radioFeedback[1]"></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LimitedRadioColumn",
  props: {
    id: {
      type: String,
    },
    titleText: {
      type: String,
      default: "Radio Title Text",
    },
    questions: {
      type: Array,
      default() {
        return [
          { value: "Radio1 Value", textbox: false },
          { value: "Radio2 Value", textbox: true },
        ];
      },
    },
    currentInput: {
      type: Array,
      default() {
        return [];
      },
    },
    multipleValues: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    nextIndex() {
      if (this.selected < 5) {
        this.selected++;
      } else {
        this.selected = 0;
      }

      return this.selected;
    },
  },
  beforeMount() {
    this.radioFeedback = this.currentInput;
  },
  data() {
    return {
      radioFeedback: ["", ""],
      selected: 0,
    };
  },
  methods: {
    checkedRadio(id) {},
  },
};
</script>

<style lang="scss">
.limit-radio-column-comp {
  p {
    color: #15243c;
    font-weight: bold;
  }

  .radios {
    color: #15243c;
    .radio {
      margin-bottom: 8px;
      .radio-input {
        [type="radio"]:not(:checked) {
          position: static !important;
          opacity: 1 !important;
        }

        [type="radio"]:checked {
          position: static !important;
          opacity: 1 !important;
        }
        span {
          margin-left: 15.5px;
        }
      }
      .radio-textarea {
        margin-top: 8px;
        textarea {
          margin-left: 28.5px;
          width: 40%;
          border: 2px solid #27606c;
          border-radius: 8px;
          outline: none;
          padding: 16px;

          @media screen and (max-width: 992px) {
            width: 90%;
            padding: 0;
          }
        }
      }
    }
  }
}
</style>